import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function GrievancesRTIAdmin() {
  const [grv, setGrv] = useState([]);
  const [rti, setRti] = useState([]);
  const [tab, setTab] = useState("grievances");
  useEffect(() => {
    api.get("/grievances").then((r)=>setGrv(r.data.items)).catch(()=>{});
    api.get("/rti").then((r)=>setRti(r.data.items)).catch(()=>{});
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">Public Services</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">Grievances & RTI</h1>
      </div>
      <div className="flex rounded-full border border-border p-1 bg-muted/50 text-sm max-w-sm">
        {["grievances","rti"].map(t=>(
          <button key={t} onClick={()=>setTab(t)} className={`flex-1 px-3 py-1.5 rounded-full uppercase ${tab===t?"bg-background shadow":""}`}>{t}</button>
        ))}
      </div>
      <div className="rounded-2xl border border-border bg-card overflow-x-auto">
        <table className="w-full">
          <thead><tr>
            <th className="table-th">Tracking ID</th>
            <th className="table-th">Subject</th>
            <th className="table-th">{tab === "grievances" ? "Category" : "Applicant"}</th>
            <th className="table-th">Contact</th>
            <th className="table-th">Status</th>
            <th className="table-th">Date</th>
          </tr></thead>
          <tbody>
            {(tab === "grievances" ? grv : rti).map(g => (
              <tr key={g.id} className="border-t border-border">
                <td className="table-cell font-mono text-xs">{g.tracking_id}</td>
                <td className="table-cell font-medium">{g.subject}</td>
                <td className="table-cell text-muted-foreground">{g.category || g.applicant_name}</td>
                <td className="table-cell text-xs">{g.contact_name || g.email} · {g.contact_phone || g.phone}</td>
                <td className="table-cell"><span className={`stat-pill capitalize ${g.status === "resolved" ? "bg-emerald-500/10 text-emerald-500" : g.status === "in_progress" ? "bg-sky-500/10 text-sky-500" : "bg-amber-500/10 text-amber-500"}`}>{g.status.replace("_"," ")}</span></td>
                <td className="table-cell text-xs text-muted-foreground">{new Date(g.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
